var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M1 0h32v32H1z","key":0}),React.createElement("path",{"stroke":"#233034","strokeLinecap":"square","d":"M21.658 10.994l10.416 1.514-7.537 7.347 1.779 10.374L17 25.331l-9.316 4.898 1.779-10.374-7.537-7.347 10.416-1.514L17 1.555l4.658 9.439z","key":1})]));
}

Star.defaultProps = {"width":"34","height":"32","viewBox":"0 0 34 32"};

module.exports = Star;

Star.default = Star;
